import axios from 'axios';
import { backendUrl } from '../constants/urls';
import { DeliveryRatePayload } from '../pages/rates-management/types';
import clientApi from '../constants/urls';

const retrieveDeliveryRates = () => {
	return clientApi.get(`${backendUrl}/deliveryRates`);
};

const createDeliveryRate = (payload) => {
	return clientApi.post(`${backendUrl}/deliveryRates`, payload);
};

const updateDeliveryRate = (id, updateRatePayload) => {
	return clientApi.put(`${backendUrl}/deliveryRates/${id}`, updateRatePayload);
};

const deleteDeliveryRate = (id) => {
	return clientApi.delete(`${backendUrl}/deliveryRates/${id}`);
};

const deliveryService = {
	retrieveDeliveryRates,
	createDeliveryRate,
	updateDeliveryRate,
	deleteDeliveryRate,
};

export default deliveryService;
